/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

var splides = document.querySelectorAll('.procedure-slide');
// 1. query slider elements: are there any splide elements?
if(splides.length){
    // 2. process all instances
    for(var i=0; i<splides.length; i++){
        var splideElement = splides[i];
        //3.1 if no options are defined by 'data-splide' attribute: take these default options
        var splideDefaultOptions =
            {
                type: 'loop',
                rewind: true,
                speed: 1000,
                arrows: true,
                pagination: false,
                perPage: 3,
                perMove: 1,
                start: 1,
                focus: 'center',
                gap: '0.8%',
                breakpoints: {
                    960: {
                        perPage: 1
                    },
                }
            }

        var splide = new Splide( splideElement, splideDefaultOptions );
        // 3. mount/initialize this slider
        splide.mount();
    }
}